// Runtime resolver for static default media (e.g. the Ford square logo) used by
// search / PMax / Demand Gen ad slots.
//
// The persisted gs:// storage path MUST come from the backend so it points at
// the current environment's bucket. Hardcoding it in the frontend previously
// baked the dev bucket into prod rows, making prod ZIP downloads 403. This
// mirrors rsaDefaults.ts.

export interface DefaultMediaItem {
  /** gs:// path persisted into media_files (env-aware, from the backend). */
  storagePath: string;
  /** Preview URL served via /api/static/<path>. */
  staticUrl: string;
  /** Object path within the bucket. */
  path: string;
}

export type DefaultMediaMap = Record<string, DefaultMediaItem>;

/**
 * Fetch the environment-aware default media map from the backend.
 * Returns null on any failure so callers can fall back gracefully.
 */
export async function fetchDefaultMedia(): Promise<DefaultMediaMap | null> {
  try {
    const res = await fetch('/api/static/default-media');
    if (!res.ok) return null;
    const data: DefaultMediaMap = await res.json();
    return data;
  } catch {
    return null;
  }
}
